import { Option } from '../../option.class';
import { getPropertyDescriptor } from '../../../../functions';

import { AfterschoolHour } from './afterschool.types';

declare module '../../option.class' {
  interface Option {
    accept:number,
    waitlist:number, 
    hours:AfterschoolHour[],
    tags:string[],
  }
}
const type = 'afterschool';
let OptionValue = getPropertyDescriptor(Option.prototype, 'value');
let OptionQuota = getPropertyDescriptor(Option.prototype, 'quota');
Object.defineProperties(Option.prototype, {
  value:{
    get: function(): boolean {
      if (this.type === type) {
        // 1. add table property into value
        return {
          ...OptionValue.get.apply(this),
          accept: this.accept,
          waitlist: this.waitlist,
          quota:this.quota,
          hours: this.hours,
          tags:this.tags,
        };
      } else {
        return OptionValue.get.apply(this);
      }
    }    
  },
  accept:{
    get: function():number {
      return this.get('accept') || 0;
    },
    set: function(v:number) {
      this.set('accept', v);
    }
  },
  waitlist:{
    get: function():number {
      return this.get('waitlist') || 0;
    },
    set: function(v:number) {
      this.set('waitlist', v);
    }
  },
  hours:{
    get: function():AfterschoolHour[] {
      return this.get('hours') || [];
    },
    set: function(v:AfterschoolHour[]) {
      this.set('hours', v);
    }
  },
  tags:{
    get: function():string[] {
      return this.get('tags') || [];
    },
    set: function(v:string[]) {
      this.set('tags', v);
    }
  },
  quota:{
    get: function():number {
      if (this.type === type) {
        if (this.question.canHaveQuotaOptions) {
          return this.accept + this.waitlist;
        }
        else {
          return undefined;
        }
      } else {
        return OptionQuota.get.apply(this);
      }
    },
    set: function(v:number) {
      if (this.type === type) {
        const diff = v - this.quota;
        return this.accept = this.accept + diff; 
      } else {
        return OptionQuota.set.apply(this, [v]);
      }
    }
  },

})
console.log("option type afterschool is added");